<template>
  <card-form>

    <div class="row mt-4">
      <f-input 
        name="codigo" 
        :disabled="disabled"
        v-model="model.codigo" 
        v-validate="{required: true}" 
        data-vv-as="Código"
        label="Código"
        :modelErrors="errors"
        :cols="3"
      />
      <f-input 
        name="descricao" 
        :disabled="disabled"
        v-model="model.descricao" 
        v-validate="{required: true}" 
        data-vv-as="Descricao"
        label="Descrição"
        :modelErrors="errors"
        :cols="6"
      />
      <f-switch
        name="ativo"
        :disabled="disabled"
        v-model="model.ativo"
        :cols="12"
        :label="model.ativo ? 'Ativo' : 'Inativo'"
      />
    </div>

    <template #footer>
      <button v-if="!disabled" class="btn btn-success px-5" @click="submeter" type="button">{{ model.id == 0 ? 'Criar' : 'Alterar' }}</button>
      <button class="btn btn-info px-5" @click="() => {$router.push({name: 'cadastros.motivospendenciaauditoria.lista'})}" type="button">Voltar</button>
    </template>

  </card-form>

</template>

<script>
import CardForm from "@/components/Ui/CardForm";
import { Validator } from 'vee-validate';
import { getMotivosPendenciaAuditoria, criarMotivosPendenciaAuditoria, atualizarMotivosPendenciaAuditoria } from "@/services/motivospendenciaauditoria.service";
import { trataErro, trataInsertSucesso, trataUpdateSucesso } from "../../../../utils/tratar.retornos";
import validateCnpj from '../../../../utils/validator.cnpj'


export default {
  components: {
    CardForm,
  },
  data() {
    return {
      disabled: true,
      model: {
        id: 0,
        codigo: '',
        ativo: true,
        descricao: ''
      },
    };
  },
  mounted() {
    this.disabled = !this.$route.meta.editavel;
    if (this.$route.params.id && this.$route.params.id > 0) {
      getMotivosPendenciaAuditoria(this.$route.params.id).then(({ data }) => {
        this.model = data.resultado;
      })
      .catch((e) => 
        trataErro(e, this)
      );
    }
    
    Validator.extend('cnpj', validateCnpj);
  },
  methods: {
    async submeter(event) {
      event.preventDefault()
      var isValid = await this.$validator.validateAll();
      if (isValid) {
        if (this.model.id == 0) {
          criarMotivosPendenciaAuditoria(this.model).then(() => {
            trataInsertSucesso(this, 'cadastros.motivospendenciaauditoria.lista')
          })
          .catch((e) => 
            trataErro(e, this)
          )
        } else {
          atualizarMotivosPendenciaAuditoria(this.model).then(() => {
            trataUpdateSucesso(this, 'cadastros.motivospendenciaauditoria.lista')
          })
          .catch((e) => 
            trataErro(e, this)
          )
        }
      }
    },
  },
};
</script>